function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "currentColor",
  d: "M0 17.639c2.004 1.383 4.29 2.117 6.52 2.117 2.172 0 4.092-.621 5.446-1.778 1.27-1.101 1.92-2.738 1.92-4.883 0-2.794-1.355-4.318-4.63-5.277-2.2-.65-2.37-.734-2.934-1.186a1.234 1.234 0 0 1-.452-.931c0-.931.903-1.637 2.089-1.637 1.129 0 2.116.395 3.217 1.27l1.947-3.81C11.233.536 9.144 0 7.168 0 3.358 0 .762 2.568.762 6.35c0 1.665.508 2.907 1.496 3.725.677.565 1.496.903 3.584 1.524 2.286.678 2.935 1.157 2.935 2.173 0 1.101-.931 1.835-2.37 1.835-1.44 0-2.823-.621-4.319-1.92z"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M19.254 19.276h4.882V4.6H28.2V.452H15.274V4.6h3.98z"
}), React.createElement("path", {
  fill: "#ffa60b",
  d: "M41.428.452h-5.56l-4.177 5.531c-1.75 2.343-2.85 5.024-2.85 7.14 0 1.778.705 3.472 1.947 4.77 1.355 1.411 3.415 2.145 5.927 2.145 4.798 0 8.071-2.907 8.071-7.169 0-3.753-2.624-6.604-6.067-6.604-.903 0-1.524.141-2.625.593zM33.61 13.067a3.096 3.096 0 0 1 3.105-3.105c1.693 0 3.076 1.383 3.076 3.133 0 1.665-1.411 3.076-3.076 3.076a3.114 3.114 0 0 1-3.105-3.104z"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 44.786465 20.037779",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.6cb9ae03.svg";
export { ForwardRef as ReactComponent };